import {getServerEndPoint} from "../liveshows/webEndPoint";
import {generateBarCode, getSavedBarcode, getSavedLoginData, saveLoginData} from "../globalMethods/myConfig";

const loginUser = async (email, password, setMessage, setShowMessage) => {
    const  server = getServerEndPoint()
    const data = {
        email: email,
        password: password
    }

    try {
        const dataResponse = await fetch(server + 'user/sign-in', {
            method: 'POST', body : JSON.stringify(data), headers : {
                'content-type': 'application/json'
            }
        })
        if(dataResponse.status === 200) {
            const resp = await dataResponse.json();
            saveLoginData(resp.token, "user-token")
            window.location.href="/redirect"
        }
        else {
            setMessage("Server error no User is found in Our System, Please try again or contact support admin@km-bizz.com")
            setShowMessage(true)
        }
    }
    catch(err){
        setMessage("Server error no User is found in Our System, Please try again or contact support admin@km-bizz.com")
        setShowMessage(true)
    }

}

const loginUserByBarcode = async (email, password, setMessage, setShowMessage, barcode) => {
    const  server = getServerEndPoint()
    const data = {
        loginUserForm : {
            email: email,
            password: password
        },
        barcode : barcode
    }

    try {
        const dataResponse = await fetch(server + 'user/sign-in-barcode', {
            method: 'POST', body : JSON.stringify(data), headers : {
                'content-type': 'application/json'
            }
        })
        if(dataResponse.status === 200) {
            const resp = await dataResponse.json();
            if(resp.token){
                saveLoginData(generateBarCode(), "barcode" )
                saveLoginData( resp.token, "user-token")
                window.location.href="/barcode-message"
            }

        }
        else {
            setMessage("Server error no User is found in Our System, Please try again or contact support admin@km-bizz.com")
            setShowMessage(true)
        }
    }
    catch(err){
        setMessage("Server error no User is found in Our System, Please try again or contact support admin@km-bizz.com")
        setShowMessage(true)
    }

}
const registerUser = async (email, password, subscriptionID, setMessage, setShowMessage) => {
    const  server = getServerEndPoint()
    const data = {
        email: email,
        password: password,
        subscriptionID: subscriptionID
    }

    try {
        const dataResponse = await fetch(server + 'user/sign-up', {
            method: 'POST', body : JSON.stringify(data), headers : {
                'content-type': 'application/json'
            }
        })
        if(dataResponse.status === 200) {
            const resp = await dataResponse.json();
            if(resp.code === 200) {
                window.location.href="/"
            }
            else {
                setMessage(resp.message)
                setShowMessage(true)
            }
        }
        else {
            setMessage("Server error no User is found in Our System, Please try again or contact support admin@km-bizz.com")
            setShowMessage(true)
        }
    }
    catch (ex){
        setMessage("Server error no User is found in Our System, Please try again or contact support admin@km-bizz.com")
        setShowMessage(true)
    }


}

const checkBarcodeToken = async ()=> {
        const  server = getServerEndPoint() + 'barcode/user-qrcode?barcode=' + getSavedBarcode()
        try {
            const response = await fetch(server)
            const resp = await response.json()
            if(resp.code === 200) {
                saveLoginData(resp.token, "user-token")
                saveLoginData(generateBarCode(), "barcode")
                window.location.href="/redirect"
            }
        }
        catch(err){
        }
}

const addTokenHistory = async (token, muToken) => {
    const  server = getServerEndPoint() + 'channel/user/token'
    const data = {
        token: token,
        muToken: muToken
    }

    const dataResponse = await fetch(server , {
        method: 'POST', body : JSON.stringify(data), headers : {
            'content-type': 'application/json'
        }
    })
    if(dataResponse.status === 200) {
        console.log("EVERY time is ok ")
    }
}

const valideLogin = async () => {
   const token =  getSavedLoginData("user-token")
    if(token){
        const  server = getServerEndPoint() + 'user/valide?token=' + token
        try {
            const response = await fetch(server)
            const message = await response.json()
            if(message.code === 200) {
                return true
            }
        }
        catch(err){
            return false
        }

    }
    else {
        return false
    }
}

const userLogOut = () => {
    window.localStorage.removeItem("user-token")
    window.location.href = "/"
}

const checkSuperUser = async () => {
    const token =  getSavedLoginData("user-token")
    if(token){
        const  server = getServerEndPoint() + 'user/is-super?token=' + token
        try {
            const response = await fetch(server)
            return  await response.json();
        }
        catch(err){
            console.log(err)
        }
    }
}

export {
    loginUser,
    valideLogin,
    registerUser,
    loginUserByBarcode,
    checkBarcodeToken,
    addTokenHistory,
    userLogOut,
    checkSuperUser
}